module.exports = __webpack_public_path__ + "static/2-d04dca5bbdd7acfee2d9459bdd36f950.jpg";